import * as moment from 'moment'
import * as React from 'react'

import { DATE_FORMAT } from '../../../common/dates'
import { Dash, styled } from '../../../common/ui'
import { FormRecord } from '../../types'
import { DateIcon, PinIcon, TimeIcon } from '../icons'
import { theme } from '../theme'
import { AddToCalendarButton } from './AddToCalendarButton'
import { BigTitle } from './BigTitle'
import { Buttons } from './Buttons'
import { Container } from './Container'
import { Description } from './Description'
import { ExtraInfo } from './ExtraInfo'
import { GoBack } from './GoBack'
import { NoWrap } from './NoWrap'
import { SubTitle } from './SubTitle'
import { TextAndIcon } from './TextAndIcon'

export const HeaderContainer = styled.div`
  background: ${theme.colors.blue};
  padding-top: 25px;
  padding-bottom: 25px;
`

export class Header extends React.Component<
  { formRecord: FormRecord; addToCalendarUrl?: string; goBackUrl: string },
  {}
> {
  public render() {
    const dashColor = 'rgba(255, 255, 255, 0.4)'
    const { formRecord, addToCalendarUrl, goBackUrl } = this.props

    const date =
      formRecord.endDate !== null ? (
        <>
          <NoWrap>{moment(formRecord.startDate).format(DATE_FORMAT)}</NoWrap>
          <Dash mh={5} style={{ color: dashColor }} />
          <NoWrap>
            {moment(formRecord.endDate || '').format(DATE_FORMAT)}
          </NoWrap>
        </>
      ) : (
        <NoWrap>{moment(formRecord.startDate).format(DATE_FORMAT)}</NoWrap>
      )

    const time =
      formRecord.endTime && formRecord.endTime.length > 0 ? (
        <>
          <NoWrap>{formRecord.startTime}</NoWrap>
          <Dash mh={5} style={{ color: dashColor }} />
          <NoWrap>{formRecord.endTime}</NoWrap>
        </>
      ) : formRecord.startTime ? (
        <NoWrap>{formRecord.startTime}</NoWrap>
      ) : null
    return (
      <HeaderContainer>
        <Container>
          <BigTitle>{formRecord.title}</BigTitle>
          <SubTitle>{formRecord.subTitle}</SubTitle>
          <ExtraInfo>
            <TextAndIcon icon={<DateIcon w={30} h={30} fill="#fff" />}>
              {date}
            </TextAndIcon>
            <TextAndIcon icon={<TimeIcon w={30} h={30} fill="#fff" />}>
              {time}
            </TextAndIcon>
            <TextAndIcon icon={<PinIcon w={30} h={30} fill="#fff" />}>
              {formRecord.place}
            </TextAndIcon>
          </ExtraInfo>

          <Description
            shortBody={formRecord.shortBody}
            body={formRecord.body}
          />

          <Buttons>
            <GoBack href={goBackUrl}>Wróć do strony</GoBack>
            <AddToCalendarButton href={addToCalendarUrl} target="_blank">
              Dodaj do kalendarza
            </AddToCalendarButton>
          </Buttons>
        </Container>
      </HeaderContainer>
    )
  }
}
